import SnackbarMount, { SnackbarMountProps } from "./SnackbarMount";

function SnackbarOnError({
  duration,
  ...props
}: Omit<SnackbarMountProps, "variant">) {
  return (
    <SnackbarMount
      {...props}
      duration={duration}
      variant="error"
    />
  );
}

export default SnackbarOnError;
